module.exports = __webpack_public_path__ + "static/media/4zero4.3214a53d.png";